module.exports = __webpack_public_path__ + "img/sleep.147256ed.png";